/** 가장 구체적인 화면 패턴을 고른다. 서버 문서와 브라우저 모달이 함께 쓴다. */
export function matchHelpDocForPath<T extends { screens: string[] }>(docs: Iterable<T>, pathname: string): T | null {
  const parts = pathname.split('/').filter(Boolean);
  let best: { doc: T; length: number } | null = null;
  for (const doc of docs) {
    for (const screen of doc.screens) {
      const pattern = screen.split('/').filter(Boolean);
      if (pattern.length > parts.length) continue;
      if (pattern.length === 0 && parts.length > 0) continue;
      const fits = pattern.every((seg, i) => /^\[.+\]$/.test(seg) || seg === parts[i]);
      if (fits && (!best || pattern.length > best.length)) best = { doc, length: pattern.length };
    }
  }
  return best?.doc ?? null;
}
